<template>
    <div class="app">
        <AppHeader v-if="" fixed style="background-color: #428bca; z-index: 199" :class="{'display-none': isBauhof && !isBauhofPortal && !wasAV}">
            <SidebarToggler class="d-lg-none" display="md" mobile/>
            <b-link class="navbar-brand" to="#" style="color: #fff; font-weight: bold; width: 155px;">
                BIS-Office
            </b-link>
            <SidebarToggler class="d-md-down-none" display="lg"/>
            <b-navbar-nav class="ml-auto">
                <b-nav-item class="d-md-down-none" @click="refresh">
                    <i class="icon-refresh" style="color: #fff;"></i>
                </b-nav-item>
                <DefaultHeaderDropdownAccnt @change-password="changePassword" @switch-user="switchUser" @open-email-settings="emailSettingsModal = true"
                                            :username="username" :is-encrypted="isEncrypted" v-if="!isBauhofPortal"/>
                <DownloadWindowsDropdown v-if="windows_download && !isElectron() && !isBauhofPortal"/>
                <ChangeModuleDropdown :modules="modules"
                                      @admin="gotoAdministration"
                                      @baumkontrolle="gotoBaumKontrolle"
                                      @nutzerverwaltung="gotoNutzerverwaltung"
                                      @mobileSettings="gotoMobileSettings"
                                      @fp="gotoFp"
                                      @zk="gotoZK"
                />
                <ChangeSuiteDropdown
                        v-if="showLogOn && !isBauhofPortal"
                        :suites="suites"
                        :current="mySuite"
                        @log-on="logon"/>
                <b-nav-item class="d-md-down-none" @click="logout" v-if="!isBauhofPortal">
                    <i class="icon-logout" style="color: #fff;"></i>
                </b-nav-item>
            </b-navbar-nav>
        </AppHeader>
        <div :class="{'app-body': true, 'android-container': isBauhof && !isBauhofPortal && !wasAV, 'border-bauhof': isBauhof && !isBauhofPortal && !wasAV} " style="overflow: hidden">
            <AppSidebar fixed :class="{'height-100': isBauhof && !isBauhofPortal && !wasAV}" style="z-index: 199" v-if="!isBauhof || wasAV || isBauhofPortal">
                <SidebarHeader/>
                <SidebarForm/>
                <SidebarNav :navItems="nav" v-if="renderComponent"></SidebarNav>
                <SidebarFooter/>
                <SidebarMinimizer ref="minimize" v-on:cui-sidebar-minimize="onMinimized"/>
            </AppSidebar>
            <main class="main" style="background-color: #fff">
                <div class="container-fluid" style="padding: 0px; height: 100%">
                    <router-view ref="router_view" v-if="show" :key="$route.path" @close-side-bar="$refs.minimize.minimize()">
                    </router-view>
                </div>
            </main>
        </div>
        <b-modal title="Passwort ändern" v-model="myModal" @cancel="changePasswordCancel" @ok.prevent="changePasswordOk"
                 ok-title="Ändern"
                 cancel-title="Abbrechen"
        >
            <b-container fluid>
                <b-row>
                    <b-col md="4">
                        <p style="margin-bottom: 0; margin-top: 0.5rem;">Altes Passwort</p></b-col>
                    <b-col>
                        <b-form-input v-model="oldPwd"
                                      class="form-control text-black" type="password"
                                      v-on:focus="pwdError=''"
                        ></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="4">
                        <p style="margin-bottom: 0; margin-top: 0.5rem;">Neues Passwort</p></b-col>
                    <b-col>
                        <b-form-input v-model="newPwd1"
                                      class="form-control text-black" type="password"
                                      v-on:focus="pwdError=''"
                        ></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="4">
                        <p style="margin-bottom: 0; margin-top: 0.5rem;">Passwort wiederholen</p></b-col>
                    <b-col>
                        <b-form-input v-model="newPwd2"
                                      class="form-control text-black" type="password"
                                      v-on:focus="pwdError=''"
                        ></b-form-input>
                    </b-col>
                </b-row>
                <b-row v-if="pwdError !== ''"><p style="margin-top: 2rem; margin-left: 1rem; color: red;">
                    {{pwdError}}</p></b-row>
            </b-container>
        </b-modal>
        <b-modal title="E-Mail Benachrichtigungen" v-model="emailSettingsModal" @ok.prevent="saveEmailSettings"
                 ok-title="Speichern"
                 cancel-title="Abbrechen"
        >
            <b-container fluid>
                <b-row class="mt-2">
                    <b-col md="6">
                      <b-form-group style="margin-bottom: 0.2rem;">
                        <template #label>
                          <b-form-checkbox
                              v-model="taskAllSelected"
                              :indeterminate="taskIndeterminate"
                              @change="taskToggleAll"
                          >
                            {{ 'Aufgaben' }}
                          </b-form-checkbox>
                        </template>

                        <template v-slot="{ ariaDescribedby }">
                          <b-form-checkbox-group
                              v-model="taskSelected"
                              :options="taskOptions"
                              class="ml-4"
                              stacked
                          ></b-form-checkbox-group>
                        </template>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group style="margin-bottom: 0.2rem;">
                        <template #label>
                          <b-form-checkbox
                              v-model="newMessageSelected"
                          >
                            {{ 'Neue Nachricht' }}
                          </b-form-checkbox>
                        </template>
                      </b-form-group>
                      <b-form-group v-if="mmSelected !== undefined" style="margin-bottom: 0.2rem;">
                        <template #label>
                          <b-form-checkbox
                              v-model="mmSelected"
                          >
                            {{ 'Neue Mangelmeldung' }}
                          </b-form-checkbox>
                        </template>
                      </b-form-group>
                      <b-form-group v-if="soSelected !== undefined" style="margin-bottom: 0.2rem;">
                        <template #label>
                          <b-form-checkbox
                              v-model="soSelected"
                          >
                            {{ 'Neue Sammelabrechnung' }}
                          </b-form-checkbox>
                        </template>
                      </b-form-group>

                      <b-form-group v-if="showTodo" style="margin-bottom: 0.2rem;">
                        <template #label>
                          <b-form-checkbox
                              v-model="todoAllSelected"
                              :indeterminate="todoIndeterminate"
                              @change="todoToggleAll"
                          >
                            {{ 'Aufgabenzuweisung' }}
                          </b-form-checkbox>
                        </template>

                        <template v-slot="{ ariaDescribedby }">
                          <b-form-checkbox-group
                              v-model="todoSelected"
                              :options="todoOptions"
                              class="ml-4"
                              stacked
                          ></b-form-checkbox-group>
                        </template>
                      </b-form-group>

                    </b-col>
                </b-row>
              <b-row class="mt-3">
                <b-col>
                  <p style="color: #444444">Ein angekreuztes Kästchen bedeutet, dass in bei diesem Ereigniss eine Benachrichtigung per E-Mail versendet wird.</p>
                </b-col>
              </b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import nav_admin from '@/_nav_admin'
    import {
        Header as AppHeader,
        Aside as AppAside,
        AsideToggler,
        Footer as TheFooter,
        Breadcrumb
    } from '@coreui/vue'
    import {
        SidebarToggler,
        Sidebar as AppSidebar,
        SidebarFooter,
        SidebarForm,
        SidebarHeader,
        SidebarMinimizer,
        SidebarNav,
    } from '../custom_core_ui'
    import DefaultAside from './DefaultAside'
    import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
    import DownloadWindowsDropdown from './DownloadWindowsDropdown'
    import ChangeModuleDropdown from './ChangeModuleDropdown'
    import ChangeSuiteDropdown from './ChangeSuiteDropdown'
    import {
      arrayContains,
      Cookie_Path, debug, HUB_SERVER,
      Redirect_500,
      Redirect_Login,
      Server_LOGOUT,
      Server_URL, test,
      URL_BAUMKONTROLLE, URL_MOBILE_SETTINGS,
      URL_NUTZERVERWALTUNG, URL_ZK
    } from "../shared/utils";
    import {arrayBufferToBase64, decryptTable, encryptAESWithPw, getKey, getValue} from "../shared/crypto";
    import {CrossStorageClient} from "cross-storage"
    import {cookieDelete, storageDelete, storageSet} from "../shared/electron";
    import {signIn, setToken} from "@/shared/firebase";


    // The Stammdaten "Import" entry is only offered to administrators; the
    // import endpoints check the permission again on the server.
    function stammdatenNav(group, isAdmin) {
      if (isAdmin) {
        return group;
      }
      return Object.assign({}, group, {
        children: (group.children || []).filter(child => !/\/import$/.test(child.url || '')),
      });
    }

    export default {
        name: 'DefaultContainer',
        components: {
            ChangeModuleDropdown,
            AsideToggler,
            AppHeader,
            AppSidebar,
            AppAside,
            TheFooter,
            Breadcrumb,
            DefaultAside,
            DefaultHeaderDropdownAccnt,
            SidebarForm,
            SidebarFooter,
            SidebarToggler,
            SidebarHeader,
            SidebarNav,
            SidebarMinimizer,
            DownloadWindowsDropdown,
            ChangeSuiteDropdown
        },

        created: function () {
          this.storage =  null;
          this.isAndroid = navigator.userAgent === "BisOfficeMobile";
          this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
          this.isBauhofPortal = navigator.userAgent.startsWith("Windows - BisOffice Portal");
          this.wasAV = window.location.href.endsWith("/bauhof/aufgabenverwaltung")
          if (this.isBauhof) {
          }
            if (!this.$cookies.isKey("ps") && !this.isAndroid && !this.isBauhof) {
                window.location = Redirect_Login;
              return;
            }
            if (this.$cookies.isKey("ps_username")) {
                this.username = this.$cookies.get("ps_username");
            }
            this.setCookie("ps_module", "4", -1, null, Cookie_Path, true);

            this.doInitRequest();
            if (this.isElectron()) {
                let url = window.location.href;
                window.top.postMessage({typ: 'url', url: url}, "*");
            }
        },
        data() {
            return {
              isAndroid: false,
              isBauhof: false,
              isBauhofPortal: false,
                nav: [],
                freigabe: [{
                    name: 'Freigabe',
                    url: '/auftraege/freigabe/offen',
                },
                    {
                        name: 'Abgelehnt',
                        url: '/auftraege/freigabe/abgelehnt',
                    }],
                renderComponent: true,
                loader: undefined,

                myModal: false,

                oldPwd: "",
                newPwd1: "",
                newPwd2: "",

                pwdError: "",
                errorEmpty: "Die Passwörter dürfen nicht leer sein.",
                errorUneven: "Die neuen Passwörter stimmen nicht überein.",
                errorInvalid: "Ihr eingegebenes Passwort ist falsch.",
                username: "Einstellungen",
                windows_download: false,
                permission: 2,
                modules: [],
              suiteModules: [],
                show: false,
                encryption: [],
                checksum: 0,
                isEncrypted: false,
                showLogOn: false,
                suites: [],
                mySuite: {},
              // Email settings
              emailSettingsModal: false,
              possibleSettings: [
                {text: "Neuvergabe", value: 0},
                {text: "Annahme", value: 1},
                {text: "Fertigstellung", value: 2},
                {text: "Abrechnung", value: 3},
                {text: "Ablehnung", value: 4},
                {text: "Löschung", value: 5},
                {text: "Neue Zuweisung", value: 6},
                {text: "Zuweisung abgeschlossen", value: 7},
                {text: "Zuweisung zurückgezogen", value: 8},
                {text: "Neue Nachricht", value: 9},
                {text: "Neue Mangelmeldung", value: 10},
                {text: "Neue Sammelabrechnung", value: 11},
              ],
              taskOptions: [],
              taskSelected: [],
              taskAllSelected: false,
              taskIndeterminate: false,

              showTodo: false,
              todoOptions: [],
              todoSelected: [],
              todoAllSelected: false,
              todoIndeterminate: false,

              newMessageSelected: false,
              soSelected: undefined,
              mmSelected: undefined,
              wasAV: false,
            }
        },
      watch: {
        taskSelected(newValue, oldValue) {
          if (newValue.length === 0) {
            this.taskIndeterminate = false
            this.taskAllSelected = false
          } else if (newValue.length === this.taskOptions.length) {
            this.taskIndeterminate = false
            this.taskAllSelected = true
          } else {
            this.taskIndeterminate = true
            this.taskAllSelected = false
          }
        },
        todoSelected(newValue, oldValue) {
          if (newValue.length === 0) {
            this.todoIndeterminate = false
            this.todoAllSelected = false
          } else if (newValue.length === this.todoOptions.length) {
            this.todoIndeterminate = false
            this.todoAllSelected = true
          } else {
            this.todoIndeterminate = true
            this.todoAllSelected = false
          }
        }
      },
        methods: {
          log(e) {
            console.log(e);
          },
          doInitRequest() {
            if (this.isBauhof && (!sessionStorage.getItem("customer_package") || !this.$cookies.get("ps_user_id"))) {
              this.showLoader();
              try {
                windowsCredentialService.onRequestCredentials().then(r => {
                  if (r && r.Aes) {
                    sessionStorage.setItem("aes", r.Aes);
                    sessionStorage.setItem("authorisation", r.Auth)
                    sessionStorage.setItem("customer_number", r.CustomerNumber)
                    sessionStorage.setItem("customer_package", r.CustomerPackage)
                    this.setCookie("ps_user_id", r.UserId, -1, null, Cookie_Path, true);
                    this.doInitRequest();
                  }
                }).catch(e => {
                  console.log(e)
                });
              } catch (e) {
                console.log(e);
              }
            } else {
              // check if we are in the windows webview and if so delay until all cookies are set
              //if (!this.isBauhof || (sessionStorage.getItem("customer_package") && this.$cookies.get("ps_user_id"))) {
              this.$http.get(
                  Server_URL + '/auftragsbuch/data/settings'
              ).then(this.responseOkGet, this.responseError)
              /*} else {
              setTimeout(this.doInitRequest, 250)
            }*/
            }
          },
          saveEmailSettings() {
            let data = [];
            if (this.soSelected !== undefined) {
              data.push({
                setting_type: 11,
                setting_value: this.soSelected ? 'true' : 'false'
              })
            }
            if (this.mmSelected !== undefined) {
              data.push({
                setting_type: 10,
                setting_value: this.mmSelected ? 'true' : 'false'
              })
            }
            data.push({
              setting_type: 9,
              setting_value: this.newMessageSelected ? 'true' : 'false'
            })
            if (this.showTodo) {
              for (let i = 0; i < this.todoOptions.length; i++) {
                let cur = this.todoOptions[i];
                data.push({
                  setting_type: cur.value,
                  setting_value: arrayContains(this.todoSelected, cur.value) ? 'true' : 'false'
                })
              }
            }
            for (let i = 0; i < this.taskOptions.length; i++) {
              let cur = this.taskOptions[i];
              data.push({
                setting_type: cur.value,
                setting_value: arrayContains(this.taskSelected, cur.value) ? 'true' : 'false'
              })
            }
            this.showLoader();
            this.$http.post(
                Server_URL + '/auftragsbuch/inbox/settings',
                data
            ).then(this.responseOkEmailSettings, this.responseErrorEmailSettings)
          },
          responseOkEmailSettings(response) {
            this.hideLoader();
            this.emailSettingsModal = false;
          },
          responseErrorEmailSettings(response) {
            this.hideLoader();
            this.emailSettingsModal = false;
          },
          taskToggleAll(checked) {
            if (!checked) {
              this.taskSelected = [];
            } else {
              let res = [];
              for (let i = 0; i < this.taskOptions.length; i++) {
                res.push(this.taskOptions[i].value);
              }
              this.taskSelected = res;
            }
          },
          todoToggleAll(checked) {
            if (!checked) {
              this.todoSelected = [];
            } else {
              let res = [];
              for (let i = 0; i < this.todoOptions.length; i++) {
                res.push(this.todoOptions[i].value);
              }
              this.todoSelected = res;
            }
          },
            showLoader() {
              if (this.loader === undefined) {
                this.loader = this.$loading.show();
              }
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseOkLogout(response) {
                this.hideLoader();
                sessionStorage.clear();
                window.location = Redirect_Login;
            },
            responseOkGet(response) {
            let redirect = false;
                if (response.status === 200 && response.body.status === "ok") {
                    let nav = [];
                    this.suiteModules = response.body.data.suite_modules;
                  this.modules = response.body.data.modules;
                  sessionStorage.setItem("modules", JSON.stringify(this.modules));
                  sessionStorage.setItem("suite_modules", JSON.stringify(this.suiteModules));
                  console.log(this.modules)
                  if ((!this.isBauhof || this.isBauhofPortal) && !arrayContains(this.modules, 19)) {
                    nav.push(nav_admin.items.header);
                  } else {
                    nav.push(nav_admin.items.header_av)
                  }
                    if (
                        arrayContains(this.suiteModules, 17)
                    ) {
                      nav.push(nav_admin.items.inbox);
                    } else if(this.$route.path === '/inbox/messages') {
                      this.$router.replace('/auftraege/alle')
                    }
                  if (arrayContains(this.suiteModules, 6) &&
                      arrayContains(this.suiteModules, 21)
                  ) {
                    nav.push(nav_admin.items.chat);
                  }
                    if (response.body.data.settings.use_anfrage) {
                        nav.push(nav_admin.items.anfragen);
                    }
                    if (response.body.data.settings.use_angebot) {
                        nav.push(nav_admin.items.angebote);
                    }
                    if (response.body.data.settings.fg_stufe1) {
                        nav_admin.items.auftraege.children.push(this.freigabe[0], this.freigabe[1]);
                    }
                        if (arrayContains(this.modules, 9) || arrayContains(this.suiteModules, 18) || arrayContains(this.modules, 19)) {
                            //nav.push(nav_admin.items.anfragen);
                            if (arrayContains(this.modules, 19)) {
                              let bhAufgaben = {...nav_admin.items.aufgaben_bh};
                              bhAufgaben.children = [...nav_admin.items.aufgaben_bh.children]
                              if (arrayContains(this.suiteModules, 24)) {
                                bhAufgaben.children.push(nav_admin.items.series);
                              }
                              if (arrayContains(this.suiteModules, 29)) {
                                bhAufgaben.children.push(nav_admin.items.predefined_tours);
                              }
                              nav.push(bhAufgaben);
                              if (arrayContains(this.suiteModules, 25)) {
                                nav.push(nav_admin.items.planning);
                              }
                              /*if (arrayContains(this.suiteModules, 22)) {
                                nav.push(nav_admin.items.touren_pro);
                              }*/
                            } else {
                              nav.push(nav_admin.items.aufgaben);
                            }
                            if (!arrayContains(this.modules, 19)) {
                              nav.push(nav_admin.items.aufgaben_from_me);
                            }
                        } else {
                          let n = JSON.parse(JSON.stringify(nav_admin.items.auftraege))
                          if (arrayContains(this.modules, 35)) {
                            n.children.push({
                              name: 'Rechnungsliste',
                              url: '/auftraege/rechnungs_liste',
                            })
                          }
                          nav.push(n);
                        }
                  if (arrayContains(this.modules, 11)) {
                    nav.push(nav_admin.items.geo_referencing);
                  }
                  if (arrayContains(this.modules, 31)) {
                    nav.push(nav_admin.items.cadastre);
                  }

                  if ((arrayContains(this.suiteModules, 33) && arrayContains(this.modules, 19))) {
                    nav.push(stammdatenNav(nav_admin.items.stamm_sub,
                        response.body.data.permission === 9 || this.$cookies.get("ps_username") === 'admin'));
                  } else if (this.$cookies.get("ps_customer_number") === "7678978" ||
                      this.$cookies.get("ps_customer_number") === "7678986" ||
                      this.$cookies.get("ps_customer_number") === "8888810" ||
                      (this.$cookies.get("ps_customer_number") === "1293425" && arrayContains(this.modules, 19)) ||
                      (this.$cookies.get("ps_customer_number") === "3155200" && arrayContains(this.modules, 19)) ||
                      (this.$cookies.get("ps_customer_number") === "5168800" && arrayContains(this.modules, 19)) ||
                      (this.$cookies.get("ps_customer_number") === "5451600" && arrayContains(this.modules, 19))
                  ) {
                    nav.push(nav_admin.items.stamm);
                  }
                  if ((arrayContains(this.suiteModules, 33) && arrayContains(this.modules, 19))) {
                    if (this.$cookies.get("ps_customer_number") === "admin") {
                      nav.push(nav_admin.items.calculation_admin);
                    } else {
                      nav.push(nav_admin.items.calculation);
                    }
                  }

                    if (response.body.data.permission === 9 && (!this.isBauhof || this.isBauhofPortal)) {
                        nav.push(nav_admin.items.footer)
                    }
                    this.permission = response.body.data.permission;
                    this.modules = response.body.data.modules;
                    this.mySuite = response.body.data.my_suite;
                    this.suites = response.body.data.suite_links;
                    if (this.isElectron() && this.suites !== null
                        && this.suites !== undefined && this.suites.length > 0) {
                        this.showLogOn = true;
                    }
                    this.nav = nav;
                    this.windows_download = response.body.data.settings.windows_download;

                    this.isEncrypted = response.body.data.is_encrypted;
                    this.encryption = response.body.data.encryption;
                    this.checksum = response.body.data.checksum;
                    if (!this.hasModule(4)) {
                        // unauthorized
                        this.hideLoader();
                        window.location = Redirect_500;
                    }
                    let mailSettings = response.body.data.email_settings;
                    mailSettings.sort((a,b) => (a.setting_type > b.setting_type) ? 1 : ((b.setting_type > a.setting_type) ? -1 : 0))
                  for (let i = 0; i < mailSettings.length; i++) {
                    let current = mailSettings[i];
                    if (current.setting_type < 6) {
                      this.taskOptions.push(this.possibleSettings[current.setting_type]);
                      if (current.setting_value === "true"){
                        this.taskSelected.push(current.setting_type)
                      }
                    } else if (current.setting_type >= 6 && current.setting_type < 9) {
                      this.showTodo = true;
                      this.todoOptions.push(this.possibleSettings[current.setting_type]);
                      if (current.setting_value === "true"){
                        this.todoSelected.push(current.setting_type)
                      }
                    } else if (current.setting_type === 9) {
                      this.newMessageSelected = current.setting_value === "true";
                    } else if (current.setting_type === 10) {
                      this.mmSelected = current.setting_value === "true";
                    } else if (current.setting_type === 11) {
                      this.soSelected = current.setting_value === "true";
                    }
                  }

                  if (this.isEncrypted) {
                    this.authFirebaseUser(response.body.data.firebase_token);
                    } else {
                        this.hideLoader();
                        this.show = true;
                    }
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            authFirebaseUser(token) {
              if (token !== undefined && token !== null && token !== '') {
                signIn(token).then(res => {
                  this.loadSession();
                }).catch(err => {
                  console.log(err)
                  this.loadSession();
                })
              } else {
                this.loadSession();
              }
            },
          onMinimized() {
            if (this.$refs.router_view === undefined || this.$refs.router_view.$children.length === 0) {
              return;
            }
            let time = 0;
            let interval = window.setInterval(() => {
              if (time >= 300) {
                window.clearInterval(interval);
              }
              if (this.$refs.router_view.$children.length === 1 && typeof this.$refs.router_view.$children[0].onSidebarToggle === "function") {
                this.$refs.router_view.$children[0].onSidebarToggle();
              }
              time += 25;
            }, 25);
          },
            responseError(response) {
                if (response.status === 401) {
                  if (this.isBauhof) {
                    setTimeout(() => this.doInitRequest(), 250)
                  }
                  this.hideLoader();
                    //window.location = Redirect_Login;
                } else {
                  this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            logout() {
                if (this.isElectron()) {
                    window.top.postMessage("close", "*");
                } else {
                    this.switchUser();
                }
            },
            switchUser() {
                this.showLoader();
                this.$cookies.remove("ps_pw", null, Cookie_Path);
                cookieDelete("ps_pw");
                this.clearLinks().then(res => this.$http.post(
                    Server_LOGOUT + '/stammdaten/logout'
                ).then(this.responseOkLogout, this.responseError))
            },
            changePassword() {
                this.myModal = !this.myModal;
            },
            changePasswordOk() {
                if (this.oldPwd === '' || this.newPwd1 === '' || this.newPwd2 === '') {
                    this.pwdError = this.errorEmpty;
                    return
                } else if (this.newPwd2 !== this.newPwd1) {
                    this.pwdError = this.errorUneven;
                    return;
                }
                this.showLoader();
                if (this.isEncrypted) {
                    if (this.storage === null) {
                        this.storage = new CrossStorageClient(HUB_SERVER);
                    }
                    this.storage.onConnect().then(() => {
                        getKey(this.$cookies.get("ps_customer_number") + this.$cookies.get("ps_username") + "cert").then(res => {
                            this.storage.get(res)
                                .then(res => {
                                    getValue(res).then(res => {
                                        let cert = JSON.parse(res);
                                        encryptAESWithPw(this.newPwd1, cert.priv).then(res => {
                                            this.$http.post(
                                                Server_URL + '/stammdaten/suite/user/change_password',
                                                {pwd: this.oldPwd, new_pwd: this.newPwd1, restore: res}
                                            ).then(this.responsePwdOk, this.responsePwdError)
                                        })
                                    });
                                })
                        })
                    }).catch(err => console.log(err))
                } else {
                    this.$http.post(
                        Server_URL + '/stammdaten/suite/user/change_password',
                        {pwd: this.oldPwd, new_pwd: this.newPwd1}
                    ).then(this.responsePwdOk, this.responsePwdError)
                }
            },
            changePasswordCancel() {
                this.oldPwd = "";
                this.newPwd1 = "";
                this.newPwd2 = "";
                this.pwdError = "";
            },
            responsePwdOk(response) {
                this.hideLoader();
                this.myModal = false;
                if (this.isElectron()) {
                    this.setCookie("ps_pw", this.newPwd1, -1, null, Cookie_Path, true);
                    this.saveUserToLocalStorage(true, this.mySuite.value_2).then(res => console.log(res)).catch(res => console.log(res));
                }
            },
            responsePwdError(response) {
                this.hideLoader();
                this.pwdError = this.errorInvalid;
            },
            refresh() {
                location.reload();
            },
            isElectron() {
                let userAgent = navigator.userAgent.toLowerCase();
                return userAgent.indexOf(' electron/') > -1;
            },
            gotoBaumKontrolle() {
                window.location = URL_BAUMKONTROLLE;
            },
            gotoNutzerverwaltung() {
                window.location = URL_NUTZERVERWALTUNG;
            },
            gotoAdministration() {

            },
            gotoMobileSettings() {
                window.location = URL_MOBILE_SETTINGS;
            },
          gotoFp() {
            window.location = 'https://fuhrpark.bisoffice.app/';
          },
          gotoZK() {
            window.location = URL_ZK;
          },
            logon(event) {
                this.showLoader();
                this.saveUserToLocalStorage(false, this.mySuite.value_2).then(res => {
                    sessionStorage.clear();
                    this.hideLoader();
                    window.location = Redirect_Login + "?switch_suite=" + event + "&user=" + this.$cookies.get("ps_username");
                }).catch(res => {
                    console.log(res);
                    this.hideLoader();
                });
            },
            hasModule(module) {
                for (let i = 0; i < this.modules.length; i++) {
                    if (this.modules[i] === module) {
                        return true;
                    }
                }
                return false
            },
            loadSession() {
                let check = sessionStorage.getItem("_checksum_");
                if (this.checksum !== 0 && check !== null && this.checksum.toString() === check) {
                  sessionStorage.setItem("modules", JSON.stringify(this.modules));
                  sessionStorage.setItem("suite_modules", JSON.stringify(this.suiteModules));
                  this.hideLoader();
                    this.show = true;
                    return
                }
                if (!this.isAndroid && !this.isBauhof) {
                  this.storage = new CrossStorageClient(HUB_SERVER);
                  this.storage.onConnect().then(() => {
                    getKey(this.$cookies.get("ps_customer_number") + this.$cookies.get("ps_username") + "aes").then(res => {
                      this.storage.get(res)
                          .then(res => {
                            getValue(res).then(res => {
                              sessionStorage.clear();
                              sessionStorage.setItem("aes", res);
                              sessionStorage.setItem("modules", JSON.stringify(this.modules));
                              sessionStorage.setItem("suite_modules", JSON.stringify(this.suiteModules));
                              decryptTable(res, this.encryption).then(res => {
                                this.encryption = res;
                                for (let i = 0; i < this.encryption.length; i++) {
                                  sessionStorage.setItem(this.encryption[i].id, JSON.stringify(this.encryption[i]));
                                }
                                sessionStorage.setItem("_checksum_", this.checksum.toString());
                                this.hideLoader();
                                this.show = true;
                              })
                            })
                          })
                    })
                  }).catch(err => console.log(err))
                } else {
                  let res = sessionStorage.getItem("aes");
                  let authorisation = sessionStorage.getItem("authorisation");
                  let customer_number = sessionStorage.getItem("customer_number");
                  let customer_package = sessionStorage.getItem("customer_package");
                  let payloadId = sessionStorage.getItem("payload_id");
                  let payload = sessionStorage.getItem(payloadId);
                  sessionStorage.clear();
                  if (payloadId && payloadId !== "") {
                    sessionStorage.setItem("payload_id", payloadId);
                    sessionStorage.setItem(payloadId, payload);
                  }
                  sessionStorage.setItem("aes", res);
                  sessionStorage.setItem("authorisation", authorisation);
                  sessionStorage.setItem("customer_number", customer_number);
                  sessionStorage.setItem("customer_package", customer_package);
                  sessionStorage.setItem("modules", JSON.stringify(this.modules));
                  sessionStorage.setItem("suite_modules", JSON.stringify(this.suiteModules));
                  this.$cookies.set("ps_customer_number", customer_number, -1, null, Cookie_Path, true);
                  decryptTable(res, this.encryption).then(res => {
                    this.encryption = res;
                    for (let i = 0; i < this.encryption.length; i++) {
                      sessionStorage.setItem(this.encryption[i].id, JSON.stringify(this.encryption[i]));
                    }
                    sessionStorage.setItem("_checksum_", this.checksum.toString());
                    this.hideLoader();
                    this.show = true;
                  }).catch(err => console.log(err))
                }
            },
            receiveMessage(e) {
                if (e.data !== undefined && e.data.typ === "auftrag") {
                    this.hideLoader();
                    this.$router.push("/auftraege/auftrag/" + e.data.auftrag);
                }
            },
            async clearLinks() {
                if (!this.isElectron()) {
                    return
                }
                if (this.storage === null) {
                    this.storage = new CrossStorageClient(HUB_SERVER);
                }
                await this.storage.onConnect();
                let res = await this.storage.get("links");
                if (res === null || res === "") {
                    return
                }
                let links = JSON.parse(res);
                for (let i = 0; i < links.length; i++) {
                    storageDelete(links[i].customer_number);
                    await this.storage.del(links[i].customer_number);
                }
                storageDelete("links");
                return this.storage.del("links");

            },
            async saveUserToLocalStorage(doCheck, suiteName) {
                if (!this.isElectron()) {
                    return
                }
                if (this.storage === null) {
                    this.storage = new CrossStorageClient(HUB_SERVER);
                }
                await this.storage.onConnect();

                let res = await this.storage.get(this.$cookies.get("ps_customer_number"))
                if ((res === null || res === "") && doCheck) {
                    return;
                } else {

                    let links = [];
                    links.push({
                        customer_number: this.$cookies.get("ps_customer_number"),
                        customer_name: suiteName,
                    });

                    for (let i = 0; i < this.suites.length; i++) {
                        links.push({
                            customer_number: this.suites[i].id,
                            customer_name: this.suites[i].value_2,
                        });
                    }
                    storageSet("links", JSON.stringify(links));
                    await this.storage.set("links", JSON.stringify(links));
                    let user = {
                        user_id: this.$cookies.get("ps_user_id"),
                        username: this.$cookies.get("ps_username"),
                        pw: this.$cookies.get("ps_pw"),
                        suite_id: this.$cookies.get("ps_customer_number"),
                        suite_name: suiteName,
                    };
                    storageSet(this.$cookies.get("ps_customer_number"), JSON.stringify(user));
                    return this.storage.set(this.$cookies.get("ps_customer_number"), JSON.stringify(user))
                }

            },
            setCookie(keyName, value, expireTimes, path, domain, secure) {
                this.$cookies.set(keyName, value, expireTimes, path, domain, secure);
                if (this.isElectron()) {
                    window.top.postMessage(
                        {
                            typ: 'cookie',
                            keyName: keyName,
                            value: value,
                            expireTimes: expireTimes,
                            path: path,
                            domain: domain,
                            secure: secure
                        }, "*");
                }
            },
        },
        mounted() {
            window.addEventListener('message', this.receiveMessage)
        },
        beforeDestroy() {
            window.removeEventListener('message', this.receiveMessage)
        },
        computed: {
            name() {
                return this.$route.name
            },
            list() {
                return this.$route.matched.filter((route) => route.name || route.meta.label)
            }

        }
    }
</script>

<style>
.dropdown-menu-right {
    right: 0 !important;
    left: auto !important;
    transform: none!important;
    top: 100% !important;
}
</style>

<style scoped>
    .android-container {
      margin-top: 0px !important;
    }
    .breadcrumb {
        margin-bottom: 0rem;
    }
    .display-none {
      display: none;
      height: 0px;
    }
    .height-100 {
      height: 100vh !important;
    }
    .border-bauhof {
      border-top: 1px solid #767373;
    }
</style>
